import { NotificationStatus } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsEnum } from "class-validator";

export class UpdateNotification {    
    @ApiProperty()
    @IsNotEmpty()
    plantId: number;
    @ApiProperty()
    @IsNotEmpty()
    palletId: number;
    @ApiProperty()
    @IsNotEmpty()
    jobId: number;
    @ApiProperty()
    @IsNotEmpty()
    verificationJobId: number;   
    @ApiProperty({enum:Object.values(NotificationStatus)})
    @IsNotEmpty()
    @IsEnum(NotificationStatus)
    status:NotificationStatus;   
    @ApiProperty()
    @IsNotEmpty()
    statusMessage: string;
    @ApiProperty()
    @IsNotEmpty()
    updatedUser: string;     
  }